export function urlifyGlobalId(globalId: string | undefined | null): string {
  if (!globalId) return ''
  return globalId.replace('gid://myomr/', '').replace('/', '-')
}

export function globalizeUrlifiedId(urlifiedId: string | undefined | null): string {
  if (!urlifiedId) return ''
  return `gid://myomr/${urlifiedId.replace('-', '/')}`
}
